import { ReactNode, SyntheticEvent } from 'react';
import classNames from 'classnames';

export type ButtonType = 'primary' | 'secondary' | 'tertiary' | 'google' | 'facebook' | 'none' | 'blank' | 'link';

type Props = {
  ariaLabel?: string;
  border?: string;
  children?: ReactNode;
  className?: string;
  dataTestId?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  href?: string;
  icon?: string;
  iconClassName?: string;
  iconLeftAligned?: boolean;
  id?: string;
  isSubmit?: boolean;
  role?: string;
  size?: 'sm' | 'lg' | 'lg-wide';
  tabIndex?: number;
  text?: string | ReactNode;
  transitional?: boolean;
  type?: ButtonType;
  onClick?: (e: SyntheticEvent) => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

export default function Button({
  ariaLabel,
  border,
  children,
  className = '',
  dataTestId,
  disabled = false,
  fullWidth = false,
  href,
  icon,
  iconClassName,
  iconLeftAligned = true,
  id,
  isSubmit = false,
  role,
  size,
  tabIndex,
  text = '',
  transitional = false,
  type = 'primary',
  onClick = () => {},
  onMouseEnter = () => {},
  onMouseLeave = () => {},
}: Props) {

  const onClickExtended = (e) => {
    onClick(e);
    if (href) {
      window.location.href = href;
    }
  };

  const classes = classNames({
    'btn--full-width': fullWidth,
    'btn--transitional': transitional,
    btn: true,
    [`btn-${type}`]: !!type,
    [`btn-${size}`]: !!size,
    [className]: className,
  });

  const iconClasses = classNames({
    icon: true,
    [`icon-${icon}`]: true,
    [iconClassName]: !!iconClassName,
  });

  return (
    <button
      aria-label={ariaLabel}
      className={classes}
      data-test-id={dataTestId}
      disabled={disabled}
      id={id}
      role={role}
      style={border ? {border} : null}
      tabIndex={tabIndex}
      type={isSubmit ? 'submit' : 'button'}
      onClick={onClickExtended}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {icon && iconLeftAligned && <span className={iconClasses} />}
      {icon && iconLeftAligned && ' '}
      {text || children}
      {transitional && <span className="icon icon-right-open" />}
      {icon && !iconLeftAligned && ' '}
      {icon && !iconLeftAligned && <span className={iconClasses} />}
    </button>
  );
}
